export default __webpack_public_path__ + "static/media/logo-dark.08b5a98f.svg";